export { default } from './TabsContentLoader'
